export default "__VITE_ASSET__62c422b7__"